<template>
  <div class="table-container">
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode=== 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode=== 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #name="{row}">
          <el-input v-model="row.name" placeholder="请输入名称" size="mini" />
        </template>
        <template #value="{row}">
          <el-input v-model="row.value" :disabled="mode === 'edit'" placeholder="请输入成员值" size="mini" />
        </template>
        <template #sequence="{row}">
          <el-input v-model="row.sequence" placeholder="" size="mini" />
        </template>
        <template #status="{row}">
          <el-link
            size="mini"
            :type="row.status ? 'success' : 'danger'"
            effect="dark"
          >
            {{ row.status ? '启用' : '禁用' }}
          </el-link>
        </template>
      </vxe-grid>

    </TableCommon>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rowSeq: 0,
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'name', title: '存货分类名称', slots: { default: 'name' }},
          { field: 'value', title: '存货分类编码', slots: { default: 'value' }},
          { field: 'status', title: '状态', width: 100, slots: { default: 'status' }},
          { field: 'sequence', title: '排序号', width: 100, slots: { default: 'sequence' }}
        ]
      }
    }
  },
  created() {
    if (this.editRows.length) {
      this.gridOptions.data.push(...this.editRows.map(item => {
        return { ...item }
      }))
    }
  },
  methods: {
    addRow() {
      this.gridOptions.data.push({
        name: '',
        value: '',
        status: 1,
        statusTextView: '启用',
        sequence: ++this.rowSeq
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.name || !item.value || item.sequence === '') {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/product-manage/components/DictEdit.vue